import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d18f916"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Order Items", -1))
const _hoisted_2 = { class: "mt-3 flex flex-wrap gap-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Clear Filters  ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Created:", -1))
const _hoisted_7 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = {
  key: 5,
  title: "View Detail Product",
  class: "text-xs"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 6 }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 7 }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_22 = {
  key: 8,
  class: "text-xs"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 9 }
const _hoisted_26 = { key: 10 }
const _hoisted_27 = {
  key: 11,
  class: "text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CustomerInfoCell = _resolveComponent("CustomerInfoCell")!
  const _component_OrderSourceTag = _resolveComponent("OrderSourceTag")!
  const _component_ProxyDomainPopover = _resolveComponent("ProxyDomainPopover")!
  const _component_CatalogTypeByStatusTag = _resolveComponent("CatalogTypeByStatusTag")!
  const _component_IsUseLattePaymentTag = _resolveComponent("IsUseLattePaymentTag")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ImportFileDialog = _resolveComponent("ImportFileDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionReport: _ctx.exportItemCatalogCode,
    onActionImport: _ctx.importOrderItemCatalogCode
  }), {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, {
          class: "w-full",
          gutter: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.orderName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.orderName) = $event)),
                  placeholder: "Order name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.transactionId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.transactionId) = $event)),
                  placeholder: "Transaction ID"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.productTitle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.productTitle) = $event)),
                  placeholder: "Product title"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.handle,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.handle) = $event)),
                  placeholder: "Product handle"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.catalogCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.catalogCode) = $event)),
                  placeholder: "Catalog code"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.variantTitle,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.variantTitle) = $event)),
                  placeholder: "Variant title"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_select, {
          placeholder: "FFM Status",
          modelValue: _ctx.params.status,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.status) = $event)),
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusListAgency, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value,
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    type: _ctx.getOrderStatusColor(item.value),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 2
              }, 1032, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          placeholder: "Design",
          modelValue: _ctx.params.design,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.params.design) = $event)),
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDesignFilter, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.value,
                clearable: ""
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          placeholder: "FFM Code Status",
          modelValue: _ctx.params.catalogCodeStatus,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.params.catalogCodeStatus) = $event)),
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogCodeStatusList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.value,
                clearable: ""
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          placeholder: "Personalized",
          modelValue: _ctx.params.personalized,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.params.personalized) = $event)),
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPersonalizedFilter, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.value,
                clearable: ""
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          placeholder: "Store",
          modelValue: _ctx.params.store,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.params.store) = $event)),
          clearable: "",
          filterable: "",
          remote: "",
          "remote-show-suffix": "",
          "remote-method": _ctx.getAllStoresSellers
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStore, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.appShopUrl,
                value: item.id,
                clearable: ""
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "remote-method"]),
        _createVNode(_component_el_select, {
          placeholder: "Type",
          modelValue: _ctx.params.type,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.params.type) = $event)),
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypeFilter, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.label,
                value: item.value,
                clearable: ""
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.params.isUseLattePayment,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.params.isUseLattePayment) = $event)),
          placeholder: "Payment",
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'LatteX Payment', value: true },
            { label: 'Seller Payment', value: false },
          ], (item) => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    type: item.value ? 'primary' : 'info'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 2
              }, 1032, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.daterange,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.daterange) = $event)),
            onChange: _ctx.onChangeDate,
            type: "daterange",
            "range-separator": "To",
            "start-placeholder": "Start date",
            "end-placeholder": "End date",
            shortcuts: _ctx.shortcutsDatetimePicker
          }, null, 8, ["modelValue", "onChange", "shortcuts"]),
          _createVNode(_component_el_button, {
            class: "ml-2 -mt-1",
            onClick: _ctx.clearFilters,
            title: "Refresh",
            size: "large",
            type: "info"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.state.orders,
        stripe: "",
        class: "list-items top-4"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: column.title,
              props: column.dataIndex,
              "min-width": column.minWidth
            }, {
              default: _withCtx((item) => [
                (column.dataIndex == 'name')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_router_link, {
                        to: {
                  name: 'seller.orders.detail',
                  params: { id: item.row.orderId },
                },
                        class: "text-primary font-bold"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.row.order[0].orderName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("span", _hoisted_5, [
                        _createElementVNode("p", null, [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatTime(item.row.order[0].createdAt)), 1)
                        ]),
                        (item.row?.order[0]?.transactionId)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(`${item.row.order[0].transactionId}`), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'status')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_el_tag, {
                        type: _ctx.getOrderStatusColor(item.row.status),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(item.row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'customer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_CustomerInfoCell, {
                        fullName: item.row.order[0]?.fullName,
                        address1: item.row.order[0]?.address1,
                        address2: item.row.order[0]?.address2,
                        city: item.row.order[0]?.city,
                        countryCode: item.row.order[0]?.countryCode,
                        email: item.row.order[0]?.email,
                        phone: item.row.order[0]?.phone,
                        province: item.row.order[0]?.province,
                        zipCode: item.row.order[0]?.zipCode
                      }, null, 8, ["fullName", "address1", "address2", "city", "countryCode", "email", "phone", "province", "zipCode"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'source')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_OrderSourceTag, {
                        source: item.row.order[0]?.source
                      }, null, 8, ["source"]),
                      _createVNode(_component_ProxyDomainPopover, {
                        proxyDomain: item.row.order[0]?.proxyDomain,
                        proxyId: item.row.order[0]?.proxyId,
                        proxyType: item.row.order[0]?.proxyType
                      }, null, 8, ["proxyDomain", "proxyId", "proxyType"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'catalogType')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_CatalogTypeByStatusTag, {
                        isDropship: item.row?.isDropship
                      }, null, 8, ["isDropship"]),
                      _createVNode(_component_IsUseLattePaymentTag, {
                        isUseLattePayment: item.row?.isUseLattePayment
                      }, null, 8, ["isUseLattePayment"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'title')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (item.row?.productId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_component_router_link, {
                              to: {
                    name: 's.product-detail',
                    params: { id: item.row?.productId },
                  },
                              class: "text-primary font-bold"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.row.itemName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.row.itemName), 1))
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'image')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Image",
                        width: 200,
                        trigger: "hover"
                      }, {
                        reference: _withCtx(() => [
                          _createElementVNode("img", {
                            src: item.row.imageSrc,
                            alt: "",
                            class: "w-20 h-20 cursor-pointer"
                          }, null, 8, _hoisted_17)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: item.row.imageSrc,
                            alt: "",
                            class: "w-full h-auto"
                          }, null, 8, _hoisted_16)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'design')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (item.row.artwork1)
                        ? (_openBlock(), _createBlock(_component_el_popover, {
                            key: 0,
                            placement: "top-start",
                            title: "Image",
                            width: 200,
                            trigger: "hover"
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                plain: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_20
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: item.row.artwork1,
                                alt: "",
                                class: "w-full h-auto"
                              }, null, 8, _hoisted_19)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "danger",
                            plain: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }))
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'quantity')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createElementVNode("p", null, "Qty: " + _toDisplayString(item.row.quantity || '-'), 1),
                      (item.row.sellerAmount > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Amount: " + _toDisplayString(_ctx.formatterDollars(item.row.sellerAmount)), 1))
                        : _createCommentVNode("", true),
                      (item.row.baseCost > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, " BaseCost: " + _toDisplayString(_ctx.formatterDollars(item.row.baseCost)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'custom')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.showCustom(item.row.custom)), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'orderItemVariant')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.row.variantTitle || '-'), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex == 'catalogCode')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(item.row.catalogCode || '-'), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label", "props", "min-width"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.state.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.params.limit) = $event)),
        class: "mt-6"
      }, null, 8, ["total", "pagination", "limit"]),
      _createVNode(_component_ImportFileDialog, {
        ref: "importFileDialog",
        title: "Import Catalog Code",
        multiple: false,
        accept: ".xlsx",
        onOnAfterSubmitFile: _ctx.onAfterSubmitFile
      }, null, 8, ["onOnAfterSubmitFile"])
    ]),
    _: 1
  }, 16, ["onActionReport", "onActionImport"]))
}